import { Link } from 'react-router-dom';
import './PayerHistoryPanel.css';

const FREQ_LABELS = { 1: 'Original', 7: 'Replacement', 8: 'Void' };

// Disposition of one claim in the rebill chain.
function disposition(node) {
  if (node.void_submitted_at)       return { label: 'Withdrawn at payer', cls: 'ph-withdrawn' };
  if (node.claim_status === 'voided') return { label: 'Voided', cls: 'ph-voided' };
  if (node.rebilled_to_claim_id)    return { label: 'Superseded', cls: 'ph-superseded' };
  if (node.payment_status === 'paid')   return { label: 'Paid', cls: 'ph-paid' };
  if (node.payment_status === 'denied') return { label: 'Denied', cls: 'ph-denied' };
  if (node.payment_status === 'submitted') return { label: 'Active · Submitted', cls: 'ph-active' };
  const cs = node.claim_status || '';
  return { label: `Active · ${cs.charAt(0).toUpperCase()}${cs.slice(1) || '—'}`, cls: 'ph-active' };
}

const fmt = (d) => (d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : null);

/**
 * Renders the payer-switch history for a claim's level — the linear rebill chain,
 * e.g. "Payer A (withdrawn) → Payer B (active)". Returns null when there's no history.
 */
export default function PayerHistoryPanel({ history, currentClaimId }) {
  if (!history || history.length <= 1) return null;

  return (
    <div className="cd-card cd-full-card">
      <div className="cd-card-header">
        <h3 className="cd-card-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="23 4 23 10 17 10" />
            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
          </svg>
          Payer / Submission History
        </h3>
      </div>
      <div className="cd-card-body">
        <div className="ph-list">
          {history.map((node, i) => {
            const d = disposition(node);
            const isCurrent = node.id === currentClaimId;
            return (
              <div key={node.id} className={`ph-row${isCurrent ? ' ph-row--current' : ''}`}>
                <div className="ph-step">{i + 1}</div>
                <div className="ph-main">
                  <div className="ph-payer">
                    {node.payer_name || 'Unknown payer'}
                    {node.insured_id && <span className="ph-id">ID: {node.insured_id}</span>}
                  </div>
                  <div className="ph-meta">
                    <span className={`ph-badge ${d.cls}`}>{d.label}</span>
                    <span className="ph-freq">{FREQ_LABELS[node.claim_frequency_code] || 'Original'}</span>
                    {node.submitted_at && <span className="ph-date">Submitted {fmt(node.submitted_at)}</span>}
                    {node.void_submitted_at && <span className="ph-date">Withdrawn {fmt(node.void_submitted_at)}</span>}
                    {node.rebill_reason && <span className="ph-reason">“{node.rebill_reason}”</span>}
                  </div>
                </div>
                <div className="ph-link">
                  {isCurrent
                    ? <span className="ph-current-tag">Viewing</span>
                    : <Link to={`/claims/${node.id}`}>{node.claim_number} →</Link>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
